<template>
	<div>
		<v-dialog v-model="dialog" max-width="1024" scrollable>
			<DialogHistorico :dialogValue="historico" :id="versao.id" @dialogClose="setDialogHistorico" table="versoes" />
			<v-card>
				<v-card-title>
					Cadastro de Mensagem
					<v-spacer></v-spacer>
					<v-btn icon @click="
						dialog = false
					tipoMensagem = 'versao'
						">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text v-if="!dialogLoading">
					<v-row>
						<v-col cols="8">
							<v-radio-group row v-model="tipoMensagem">
								<v-radio label="Por Versão" color="primary" :disabled="dialogLoading"
									:readonly="!userMensagens" value="versao"></v-radio>
								<v-radio label="Por CNPJ + Versão" color="primary" :disabled="dialogLoading"
									:readonly="!userMensagens" value="cnpj+versao"></v-radio>
								<v-radio label="Por CNPJ" color="primary" :disabled="dialogLoading"
									:readonly="!userMensagens" value="cnpj"></v-radio>
							</v-radio-group>
						</v-col>
						<V-spacer />
						<v-col cols="2" v-if="versao.id">
							<v-btn color="primary" @click="setDialogHistorico">
								<v-icon left>mdi-clock-time-five-outline</v-icon> Histórico
							</v-btn>
						</v-col>

					</v-row>
					Tipo:
					<v-radio-group row v-model="versao.tipo" class="mt-0">
						<v-radio label="Notificar" color="primary" :value="0"
							:disabled="dialogLoading || !this.$store.getters.user.mensagens.notificar"></v-radio>
						<v-radio label="Alertar" color="warning" :value="1"
							:disabled="dialogLoading || !this.$store.getters.user.mensagens.alertar"></v-radio>
						<v-radio label="Bloquear" color="red" :value="2"
							:disabled="dialogLoading || !this.$store.getters.user.mensagens.bloquear"></v-radio>
					</v-radio-group>
					<v-row v-if="tipoMensagem == 'cnpj+versao' || tipoMensagem == 'cnpj'">
						<v-col>
							<div class="cnpj-textarea">
								<v-textarea v-model="versao.cnpj" label="CNPJ" prepend-icon="label" type="text" required
									:disabled="dialogLoading" :readonly="!userMensagens" rows="1" auto-grow
									:max-rows="5" />
							</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-text-field v-model="versao.msg" label="Mensagem" prepend-icon="message" type="text"
								required :disabled="dialogLoading" :readonly="!userMensagens" maxlength="500"/>
						</v-col>
					</v-row>
					<v-row v-if="tipoMensagem != 'cnpj'">
						<v-col cols="12" sm="6" md="4">
							<v-text-field v-model="versao.versaoMaior" label="Versão Maior >=" prepend-icon="label"
								type="text" required :disabled="dialogLoading" :readonly="!userMensagens" />
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field v-model="versao.versaoMenor" label="Versão Menor <=" prepend-icon="label"
								type="text" required :disabled="dialogLoading" :readonly="!userMensagens" />
						</v-col>
					</v-row>
				</v-card-text>
				<v-progress-linear v-if="dialogLoading" indeterminate color="primary"></v-progress-linear>
				<v-card-actions>
					<v-btn color="red" dark v-if="exibeExcluir" @click="removeVersao">Excluir</v-btn>
					<v-spacer v-if="!dialogLoading"></v-spacer>
					<v-btn v-if="!dialogLoading" @click="dialog = false">Sair</v-btn>
					<v-btn color="primary" v-if="exibeSalvar" @click="saveVersao">{{ (this.versao.ativo || !this.versao.id) ? 'Salvar' : "Salvar e Recupar"}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-card>
			<v-card-title>
				<v-icon left color="primary">message</v-icon>Cadastro de Mensagens
				<v-spacer></v-spacer>
				<v-btn icon color="primary" x-large @click="newVersao">
					<v-icon>add_circle</v-icon>
				</v-btn>
			</v-card-title>			
			<v-card-text>
				<v-checkbox class="mt-0" label="Ativos" v-model="ativos"/>
				<v-data-table :headers="headers" :items="versoes" class="elevation-1" :loading="loading"
					disable-pagination hide-default-footer @click:row="loadVersao">
					<template v-slot:[`item.cnpj`]="{ item }">
						{{ item.cnpj.toString().substring(0, 22) + (item.cnpj.toString().length > 20 ? '...' : '') }}
					</template>
					<template v-slot:[`item.versaoMaior`]="{ item }">
						{{ item.versaoMaior.startsWith('sem versão') ? '' : item.versaoMaior }}
					</template>
					<template v-slot:[`item.versaoMenor`]="{ item }">
						{{ item.versaoMenor.startsWith('sem versão') ? '' : item.versaoMenor }}
					</template>
					<template v-slot:[`item.tipo`]="{ item }">
						<v-icon color="primary" v-if="item.tipo === 0" title="Notificar">sms</v-icon>
						<v-icon color="warning" v-if="item.tipo === 1" title="Alertar">error</v-icon>
						<v-icon color="red" v-if="item.tipo === 2" title="Bloquear">block</v-icon>
					</template>
				</v-data-table>
			</v-card-text>
		</v-card>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import DialogHistorico from '../components/shared/DialogHistorico.vue';

export default {
	data: function () {
		return {
			versoes: [],
			headers: [
				{ text: 'CNPJ', value: 'cnpj' },
				{ text: 'Versão Maior', value: 'versaoMaior' },
				{ text: 'Versão Menor', value: 'versaoMenor' },
				{ text: 'Mensagem', value: 'msg' },
				{ text: 'Tipo', value: 'tipo' },
			],
			loading: false,
			dialogLoading: false,
			dialog: null,
			versao: {},
			tipoMensagem: 'versao',
			historico: false,
			ativos: true,
		}
	},
	components: {
		DialogHistorico
	},
	computed: {
		...mapGetters(['userAdmin', 'userMensagens']),
		exibeExcluir() {
			return !this.loading && this.versao.id && this.userMensagens && this.versao.ativo
		},
		exibeSalvar() {
			return !this.loading && this.userMensagens
		},
	},
	methods: {
		async loadVersoes() {
			try {
				this.loading = true
				const response = await this.axios.get('/versoes', {
					params: {
						ativos: this.ativos
					}
				})
				this.versoes = response.data
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		async loadVersao(versao) {
			try {
				this.dialog = true
				this.versao = versao
				this.dialogLoading = true
				const response = await this.axios.get(`/versoes/${this.versao.id}`)
				this.versao = response.data

				if (this.versao.cnpj[0] && !this.versao.versaoMaior.startsWith('sem versão')) this.tipoMensagem = 'cnpj+versao'
				else if (this.versao.versaoMaior.startsWith('sem versão')) this.tipoMensagem = 'cnpj'
				else this.tipoMensagem = 'versao'
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {

				this.dialogLoading = false
			}
		},
		newVersao() {
			this.dialog = true
			this.versao = { tipo: this.$store.getters.user.mensagens.notificar ? 0 : this.$store.getters.user.mensagens.alertar ? 1 : 2 }
		},
		async saveVersao() {
			try {
				if (this.tipoMensagem == 'versao') this.versao.cnpj = ''
				if (this.tipoMensagem == 'cnpj') {
					this.versao.versaoMaior = 'sem versão'
					this.versao.versaoMenor = 'sem versão'
				}
				this.dialogLoading = true
				if (this.versao.id) {
					await this.axios.put(`/versoes/${this.versao.id}`, this.versao)
				} else {
					await this.axios.post('/versoes', this.versao)
				}

				this.$store.dispatch('showSuccess', 'Mensagens salva com sucesso')
				this.dialog = false
				this.loadVersoes()
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.dialogLoading = false
			}
		},
		async removeVersao() {
			try {
				this.dialogLoading = true
				await this.axios.delete(`/versoes/${this.versao.id}`)
				this.$store.dispatch('showSuccess', 'Mensagens excluída com sucesso!')
				this.dialog = false
				this.loadVersoes()
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.dialogLoading = false
			}
		},
		setDialogHistorico() {
			this.historico = !this.historico
		},
	},
	mounted() {
		this.loadVersoes()
	},
	watch: {
		search() {
			
		},
		tipoMensagem() {
			if (this.tipoMensagem != 'cnpj' && (this.versao.versaoMaior.startsWith('sem versão') && this.versao.versaoMenor.startsWith('sem versão'))) {
				this.versao.versaoMaior = ''
				this.versao.versaoMenor = ''
			}
		},
		ativos() {
			this.loadVersoes()
		}
	},
}
</script>

<style>
.cnpj-textarea {
	max-height: 300px;
	overflow: auto;
}
</style>